import MultiElementSelector from './MultiElementSelector';
import { Dispatch, SetStateAction } from 'react';
import { PlutoPerson } from '@/generated/model';
import { countPeopleExtended, getPeople } from '@/generated/client/person/person';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { TargetNameAndDescription, targetNameAndDescriptionStyle } from '../TargetNameAndDescription';
import { provideTargetIcon } from '../IconProvider';
import { useTranslation } from 'react-i18next';

export default function MultiDriverSelector({
  selectedDrivers,
  setSelectedDrivers,
  searchText,
  setSearchText,
  maxElementNumber,
}: {
  selectedDrivers: PlutoPerson[] | undefined;
  setSelectedDrivers: Dispatch<SetStateAction<PlutoPerson[] | undefined>>;
  searchText: string | undefined;
  setSearchText: Dispatch<SetStateAction<string | undefined>>;
  maxElementNumber: number;
}) {
  async function fetchData(
    page: number,
    pageSize: number,
    pagesToLoad: number,
    filter: string | undefined,
    order: string
  ) {
    const drivers = await getPeople({
      offset: page * pageSize,
      limit: pageSize * pagesToLoad,
      filter: filter,
      order: order,
    });
    return drivers.data;
  }
  const { t } = useTranslation();

  async function getRowCount(filter: string | undefined, ids: number[]) {
    const localFilter = filter ? filter : '';
    const count = await countPeopleExtended({ filter: localFilter, ids: ids });
    return count.data;
  }

  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      flex: 0.1,
      renderCell: (params: GridRenderCellParams) => {
        const driver = params.row;
        const checked = selectedDrivers
          ? selectedDrivers.find((selectedDriver) => selectedDriver.id === driver.id) !== undefined
          : false;
        return (
          <div className="target-cell" data-qa-element-id="driver_icon">
            <img className="idata-target-icon" src={provideTargetIcon('person')} />
            <TargetNameAndDescription
              targetName={driver.name}
              targetDescription={undefined}
              styleClassName={targetNameAndDescriptionStyle(checked, true, false)}
            />
          </div>
        );
      },
    },
  ];

  const translation = {
    header: t('filter.driverSelector'),
    placeHolder: t('filter.driverSearchPlaceholder'),
    noRows: t('filter.noRows'),
  };

  return (
    <MultiElementSelector<PlutoPerson>
      selectedElements={selectedDrivers}
      setSelectedElements={setSelectedDrivers}
      searchText={searchText}
      setSearchText={setSearchText}
      maxElementNumber={maxElementNumber}
      fetchData={fetchData}
      getRowCount={getRowCount}
      columns={columns}
      translation={translation}
    />
  );
}
